import { render, staticRenderFns } from "./PersonalFeedbackSection.vue?vue&type=template&id=2c5154a2&"
import script from "./PersonalFeedbackSection.vue?vue&type=script&lang=js&"
export * from "./PersonalFeedbackSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports